import { render, staticRenderFns } from "./OptionHealthPreferences.vue?vue&type=template&id=1423e405"
import script from "./OptionHealthPreferences.vue?vue&type=script&lang=js"
export * from "./OptionHealthPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports